import {
  DetailsList,
  DetailsListLayoutMode,
  IColumn,
  SelectionMode,
  Stack,
  Text,
} from '@fluentui/react';

import clsx from 'clsx';
import { AmountTextView } from 'common/components/AmountView/AmountTextView';
import { useCommonStyles } from 'common/styles';
import { dateFormat } from 'common/utils/dateFormats';
import React from 'react';
import {
  TravelAuthorization_travelAuthorization,
  TravelAuthorization_travelAuthorization_travelAuthorizationRevisionHistoriesByTaGroupId_nodes,
} from 'travelAuthorization/TravelPlan/view/__generated__/TravelAuthorization';
import { columns } from './column.data';
import { useStyles } from './index.styles';
import { ActiveLink } from 'common/components/ActiveRowLink';
type ItemRow =
  TravelAuthorization_travelAuthorization_travelAuthorizationRevisionHistoriesByTaGroupId_nodes;
interface RevisionHistoryProps {
  travelAuthorization:
    | TravelAuthorization_travelAuthorization
    | null
    | undefined;
}

export const RevisionHistory: React.FC<RevisionHistoryProps> = ({
  travelAuthorization,
}) => {
  const styles = useStyles();
  const commonStyles = useCommonStyles();

  const data =
    travelAuthorization?.travelAuthorizationRevisionHistoriesByTaGroupId?.nodes?.map(
      (item) => ({
        ...item,
      })
    ) || [];

  const renderColumn = (item?: ItemRow, _index?: number, column?: IColumn) => {
    if (!item || !column) return undefined;
    const fieldContent = item[column.fieldName as keyof ItemRow] as
      | string
      | null;

    switch (column.key) {
      case 'travelAuthorizationNumber':
        return (
          <Stack className={styles.columnHeight} verticalAlign="center">
            <ActiveLink
              key={item?.id}
              to={`${item.id}`}
              className={commonStyles.colorThemePrimary}
            >
              {fieldContent ? fieldContent : ''}
            </ActiveLink>
          </Stack>
        );

      case 'taTotal':
        return (
          <Stack
            horizontal
            className={clsx(styles.columnHeight, styles.rightAlignContainer)}
            verticalAlign="center"
          >
            <AmountTextView
              className={clsx(styles.amount)}
              value={fieldContent}
            />
          </Stack>
        );
      case 'dateRequested':
        return (
          <Stack className={styles.columnHeight} verticalAlign="center">
            <Text>{fieldContent ? dateFormat(fieldContent) : ''}</Text>
          </Stack>
        );
      default:
        return (
          <Stack className={styles.columnHeight} verticalAlign="center">
            <Text>{fieldContent ? fieldContent : ''}</Text>
          </Stack>
        );
    }
  };

  if (travelAuthorization && !!data?.length)
    return (
      <Stack tokens={{ padding: '10px 0px 10px 20px' }}>
        <Text variant="xLarge">Revision history</Text>
        <DetailsList
          compact
          columns={columns}
          items={data ? data : []}
          selectionMode={SelectionMode.none}
          layoutMode={DetailsListLayoutMode.justified}
          onRenderItemColumn={renderColumn}
          //   onRenderDetailsFooter={renderFooter}
        />
      </Stack>
    );
  else return null;
};
